/** Small determinate progress bar — shared by preflight asset list and marketplace partner uploads. */
export function UploadProgressBar({ percent }: { percent: number }) {
  const clamped = Math.min(100, Math.max(0, Math.round(percent)));

  return (
    <div
      className="bg-muted h-1 w-full overflow-hidden rounded-full"
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="bg-primary h-full rounded-full transition-[width] duration-300 ease-out"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
